<template>
  <span class="app-counter" data-jest="app-counter">
    {{ total }}
  </span>
</template>

<script>
export default {
  name: 'AppCounter',
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.app-counter {
  display: flex;
  align-items: center;
  font-size: 1.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  height: 100%;
  position: relative;
  color: var(--c-secondary-500);
  border-left: 1px solid var(--c-secondary-400);
  top: 2px;
  padding-left: 8px;
}
</style>
